export const REGISTRATION_STEPS = {
  credentials: {
    label: 'Create a new Account',
    route: 'credentials',
  },
  personal: {
    label: 'Personal Information',
    route: 'personal',
  },
  phone: {
    label: 'Enter Phone Number',
    route: 'phone',
  },
  verification: {
    label: 'Verification Code',
    route: 'verification',
  },
  welcome: {
    label: 'Welcome',
    route: 'welcome',
  },
};
